import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

export interface ContactFormData {
  firstName: string;
  lastName: string;
  email: string;
  message: string;
  privacyPolicy: boolean;
  timestamp?: Date;
}

@Injectable({
  providedIn: 'root'
})
export class ContactService {
  private functionUrl = `${environment.apiUrl}/api/sendContactForm`;

  constructor(private http: HttpClient) {}

  sendContactForm(data: ContactFormData): Observable<any> {
    const formData = {
      ...data,
      timestamp: new Date()
    };
    
    return this.http.post(this.functionUrl, formData).pipe(
      catchError(error => {
        console.error('Error sending contact form:', error);
        return throwError(() => new Error(
          error.error?.error || 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.'
        ));
      })
    );
  }
} 